// src/features/simulators/dispenser/types/index.ts

export const DISPENSER_SECTIONS = ['K'] as const;
export type DispenserSectionCode = typeof DISPENSER_SECTIONS[number];

export const DISPENSER_EVENT_CODES = {
  // Heartbeat
  HEARTBEAT: 'HB',
  
  // Key dispensing
  KEY_DISPENSED: 'KD_SUCCESS',
  KEY_DISPENSE_ERROR: 'KD_ERROR',
  
  // Check-in (if dispenser does PMS registration)
  CHECK_IN_COMPLETE: 'CI_COMP',
  
  // Errors
  ERROR: 'ERR',
} as const;

export const DISPENSER_CHANNEL = 'Dispenser';

export const DISPENSER_DEVICE_TYPE = 'Dispenser';

/**
 * QR Code type
 */
export enum QRCodeType {
  RESERVATION_NUMBER = 'ReservationNumber',  // Contains reservation locator
  ROOM_NUMBER = 'RoomNumber',                // Contains room number only
}

/**
 * Dispenser error codes
 */
export enum DispenserErrorCode {
  MECH_JAM = 'MECH_JAM',              // Mechanical jam in dispenser
  OUT_OF_KEYS = 'OUT_OF_KEYS',        // No keys available
  SENSOR_ERROR = 'SENSOR_ERROR',      // Sensor malfunction
  TIMEOUT = 'TIMEOUT',                // Operation timeout
  DOOR_OPEN = 'DOOR_OPEN',            // Door left open
  QR_READ_ERROR = 'QR_READ_ERROR',    // Could not read QR code
}

/**
 * Check-in source (where guest did check-in)
 */
export enum CheckInSource {
  PRE_CHECKIN = 'PreCheckIn',    // Guest did online pre-check-in
  KIOSK = 'Kiosk',               // Guest did check-in at kiosk
  DISPENSER = 'Dispenser',       // Dispenser does PMS registration
}

export interface DispenserConfig {
  apiUrl: string;
  hotelId: string;
  deviceId: string;
  count: number;
  delayBetweenDispenses: number;
  qrCodeType: QRCodeType;
  checkInSource: CheckInSource;
  errorRate: number;
  performPMSCheckIn: boolean;
  reservationNumber?: string;           
  autoGenerateReservation?: boolean;   
}

export interface DispenserStats {
  totalDispenses: number;
  successfulDispenses: number;
  failedDispenses: number;
  totalEvents: number;
  averageTime: number;
  
  // Error breakdown
  mechJamErrors: number;
  outOfKeysErrors: number;
  sensorErrors: number;
  timeoutErrors: number;
  doorOpenErrors: number;
  qrReadErrors: number;
  
  // Source breakdown
  fromPreCheckIn: number;
  fromKiosk: number;
  fromDispenser: number;
  
  startTime?: Date;
  endTime?: Date;
}

export interface DispenseResult {
  success: boolean;
  reservationNumber: string;
  roomNumber: string;
  duration: number;
  error?: string;
  errorCode?: DispenserErrorCode;
}